import generateVersionHash from '@utils/generateVersionHash';
import { createListMutations, createListState } from '@utils/storeHelpers';
import api from './constants';
import { postApi } from '@/lib/fetcher';

const orNull = (value) =>
  value === '' || value === undefined || value === null ? null : value;

const closedMerchantCategory = {
  namespaced: true,
  state: createListState(),
  mutations: createListMutations({
    countField: 'count_data',
    pageField: 'total_page',
  }),
  actions: {
    async getData(ctx, { date, page, itemsPerPage, search }) {
      ctx.commit('clearData');
      ctx.commit('setLoading', true);

      const limit = (itemsPerPage || 10).toString();
      const pageStr = (page || 1).toString();

      const cleanedSearch = {
        code: orNull(search?.code),
        category: orNull(search?.category),
        description: orNull(search?.description),
        status: orNull(search?.status),
      };

      const data = JSON.stringify({
        page: pageStr,
        limit,
        search: cleanedSearch,
        version: generateVersionHash(pageStr + limit, date),
      });

      const urlApi = api.GET_LIST_CLOSED_MERCHANT_CATEGORY;

      try {
        const responseData = await postApi(ctx, urlApi, data);

        if (responseData?.code === 200) {
          ctx.commit('setTotalData', { payload: responseData });
          ctx.commit('setData', { payload: responseData });
        }
      } catch (error) {
        console.error('Error fetching Closed Merchant Category data:', error);
      } finally {
        ctx.commit('setLoading', false);
      }
    },

    async viewData(ctx, { date, id }) {
      const idStr = String(id);

      const data = JSON.stringify({
        id: idStr,
        version: generateVersionHash(idStr, date),
      });

      const urlApi = api.VIEW_CLOSED_MERCHANT_CATEGORY;
      const responseData = await postApi(ctx, urlApi, data);

      return responseData;
    },

    async createData(ctx, { date, code, category, description, status }) {
      const data = JSON.stringify({
        code,
        category,
        description,
        status,
        version: generateVersionHash(
          code + category.toString() + description + status.toString(),
          date
        ),
      });

      const urlApi = api.CREATE_CLOSED_MERCHANT_CATEGORY;
      const responseData = await postApi(ctx, urlApi, data);

      return responseData;
    },

    async updateData(ctx, { date, id, code, category, description, status }) {
      const idStr = String(id);

      const data = JSON.stringify({
        id: idStr,
        code,
        category,
        description,
        status,
        version: generateVersionHash(
          idStr + code + category.toString() + description + status.toString(),
          date
        ),
      });

      const urlApi = api.UPDATE_CLOSED_MERCHANT_CATEGORY;
      const responseData = await postApi(ctx, urlApi, data);

      return responseData;
    },
  },
};

export default closedMerchantCategory;
